import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const fetchPosts = createAsyncThunk("posts/fetchPosts", async ({ url, FormDataDynamic }) => {
  try {
    const formData = new FormData();
    Object.keys(FormDataDynamic).forEach((key) => {
      formData.append(key, FormDataDynamic[key]);
    });

    // ✅ withCredentials (via axiosInstance) zaroori hai yahan — Login response ki
    // Set-Cookie (sid / refreshToken) tabhi browser accept karega
    const response = await axiosInstance.post(url, formData);

    return response && response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
});

const registrationSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default registrationSlice.reducer;